import { DocumentTypeDocument } from '../DocumentTypes/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { RoomDocument } from '../Rooms/queryBuilder';
import { SiteDocument } from '../Site/queryBuilder';
import { SurveyPointDocument } from '../SurveyPoints/queryBuilder';
import {
  DocumentUploadDocument,
  documentUploadPullModifier,
  documentUploadPullQueryBuilder,
} from './queryBuilder';

export function documentUploadFamilyMember(
  configBuilder: ConfigBuilder,
  documentTypes: FamilyMember<DocumentTypeDocument>,
  rooms: FamilyMember<RoomDocument>,
  sites: FamilyMember<SiteDocument>,
  surveyPoints: FamilyMember<SurveyPointDocument>,
): FamilyMember<DocumentUploadDocument> {
  const syncConfig = configBuilder<DocumentUploadDocument>(RxdbCollectionNameV2.DOCUMENT_UPLOAD);
  doNotAutoSync(syncConfig);

  // `documentUploadPullQueryBuilder` uses `documentFeed` which is based on `document`.
  const pullConfig = pull(syncConfig, documentUploadPullQueryBuilder);
  // BUG: documentUploadPullModifier should take a DocumentUploadDocument, not a DocumentUpload.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pullConfig.modifier = documentUploadPullModifier as any;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.DOCUMENT_UPLOAD, replicationState, [
    documentTypes,
    rooms,
    sites,
    surveyPoints,
  ]);
}
